import { Mail, Shield } from "lucide-react";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#05070A] border-t border-white/5 pt-20 pb-10 overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-10" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 gap-12 pb-16">
          <div>
            <div className="flex items-center gap-2">
              <Shield size={22} className="text-[#00FFA3]" strokeWidth={1.5} />
              <span className="font-heading font-extrabold text-2xl tracking-tight text-white">
                CYBER<span className="text-[#00FFA3]">VETS</span>
              </span>
            </div>
            <p className="text-slate-400 mt-4 max-w-md leading-relaxed">
              A veteran-owned cybersecurity, cloud, and AI firm bringing military
              discipline to the digital frontline.
            </p>
            <a
              href="mailto:Cybervets@outlook.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 mt-6 text-[#00FFA3] hover:text-[#00E5FF] transition-colors"
            >
              <Mail size={16} /> Cybervets@outlook.com
            </a>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
                Services
              </h4>
              <ul className="space-y-3">
                {["Cybersecurity", "Cloud Infrastructure", "AI Agents"].map(
                  (l) => (
                    <li key={l}>
                      <button
                        onClick={() => scrollTo("services")}
                        className="text-slate-300 hover:text-[#00FFA3] transition-colors text-sm"
                      >
                        {l}
                      </button>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div>
              <h4 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
                Company
              </h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => scrollTo("veteran")}
                    className="text-slate-300 hover:text-[#00FFA3] transition-colors text-sm"
                  >
                    Why CyberVets
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollTo("contact")}
                    className="text-slate-300 hover:text-[#00FFA3] transition-colors text-sm"
                  >
                    Book a Consultation
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} CyberVets. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a
              href="/login"
              data-testid="footer-admin-link"
              className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-600 hover:text-[#00FFA3] transition-colors"
            >
              Admin
            </a>
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-600">
              Proudly Veteran-Owned & Operated
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
